module.exports = __webpack_public_path__ + "img/strategy-coin.849ca751.svg";